import { createTypes, actionCreator } from 'redux-action-creator';
import { addAuthorizeHeader, getCookie } from '../../utils'

export const songbookPdfStepTypes = createTypes(['SET_PDF_OPTION', 'SET_CHORDS', 'REQUEST_SONGBOOK'], 'SONGBOOKPDF');


export const setPdfoption = (key, value) => {
  return {
      type: songbookPdfStepTypes.SET_PDF_OPTION,
      key,
      value
  };
};

export const requestSongbook = (songbookData) => {
  return dispatch => {
    
    let url = songbookData.sourceType === 'song' ? `/api/v3/core/songs/generate_pdf/` : `/api/v3/core/songbooks/generate_pdf/`

    return fetch(url, {
        method: 'POST',
        headers: addAuthorizeHeader({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-CSRFToken': getCookie("guitarpartycsrftoken"),
          credentials: 'include'
        }),
        body: JSON.stringify(songbookData)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`PDF request failed with status ${response.status}`)
      }
      return response
    });
  };
};

export const setStep = (newIndex) => {
  return {
      type: songbookPdfStepTypes.SET_STEP,
      data: newIndex,
  };
};
